export const OK = 200;
export const MOVED_PERMANENTLY = 301;
export const TEMPORARILY_MOVED = 302;
export const UNPROCESSABLE_CONTENT = 422;
export const NOT_FOUND = 404;
export const INTERNAL_SERVER_ERROR = 500;
export const CONFLICT = 409;
